import { render, staticRenderFns } from "./CriarPpag.vue?vue&type=template&id=363bfa54&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./CriarPpag.vue?vue&type=style&index=0&id=363bfa54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363bfa54",
  null
  
)

export default component.exports